import React from 'react';
import img404 from 'images/img-404.png';
import { Link } from 'react-router-dom';
import * as S from './styles';

function NotFoundPage() {
  return (
    <S.Wrapper>
      <section>
        <h4>ERROR</h4>
        <img src={img404} alt="" />
        <h4>LOOKS LIKE THE PAGE YOU ARE LOOKING FOR DOES NOT EXIST.</h4>
        <Link to="/">go to homepage</Link>
      </section>
    </S.Wrapper>
  );
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/index.js